import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Create axios instance with optimized configuration
const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 30000, // 30 second timeout
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  // Reduce payload size
  maxContentLength: 10 * 1024 * 1024, // 10MB max
  maxBodyLength: 10 * 1024 * 1024,
});

// Request interceptor - add token and optimize
axiosInstance.interceptors.request.use(
  (config) => {
    // Add auth token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - handle errors efficiently
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle 401 - Unauthorized
    // Skip auto-logout for blob requests (they handle errors themselves)
    const isBlobRequest = error.config?.responseType === 'blob';
    
    if (error.response?.status === 401 && !isBlobRequest) {
      // Clear local storage
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // Redirect to login only if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    // Handle network errors
    if (!error.response) {
      error.message = 'Network error. Please check your connection.';
    }

    // Handle timeout
    if (error.code === 'ECONNABORTED') {
      error.message = 'Request timeout. Please try again.';
    }

    return Promise.reject(error);
  }
);

// Cancel token for request cancellation
export const createCancelToken = () => axios.CancelToken.source();
export const isCancel = axios.isCancel;

export default axiosInstance;
